import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

/**
 * PageSkeleton — content-area loading placeholder for lazy routes.
 * Rendered INSIDE AppLayout (around <Outlet/>), so the sidebar + topbar stay
 * mounted and only the page content shows the skeleton. Mirrors the common
 * page shape (header, stat row, content block). Bones auto-size via
 * react-loading-skeleton.
 */
export function PageSkeleton() {
  return (
    <SkeletonTheme baseColor="hsl(var(--muted))" highlightColor="hsl(var(--accent) / 0.15)">
      <div className="flex-1 w-full p-6 space-y-4">
        <Skeleton height={32} width={200} />
        <Skeleton height={16} width={300} />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {Array.from({ length: 4 }).map((_, i) => <Skeleton key={i} height={80} borderRadius={12} />)}
        </div>
        <Skeleton height={260} borderRadius={12} />
      </div>
    </SkeletonTheme>
  );
}
